import { render, staticRenderFns } from "./pageheader.vue?vue&type=template&id=57d9835e&scoped=true"
import script from "./pageheader.vue?vue&type=script&lang=js"
export * from "./pageheader.vue?vue&type=script&lang=js"
import style0 from "./pageheader.vue?vue&type=style&index=0&id=57d9835e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d9835e",
  null
  
)

export default component.exports